import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SCRIPT_ID = "metricool-tracker-script";
const SCRIPT_SRC = "https://tracker.metricool.com/resources/be.js";
const TRACKER_HASH = process.env.REACT_APP_METRICOOL_HASH;
const PRIVATE_PATHS = [
  "/admin",
  "/salon/admin",
  "/salon/billing",
  "/booking/confirmed",
];

let scriptPromise;
let lastTrackedPage;

export function isMetricoolPublicPath(pathname) {
  const normalized = pathname.replace(/\/+$/, "") || "/";
  return !PRIVATE_PATHS.some((path) => normalized === path || normalized.startsWith(`${path}/`));
}

function loadMetricool() {
  if (window.beTracker) return Promise.resolve();
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    const existing = document.getElementById(SCRIPT_ID);
    if (existing) {
      existing.addEventListener("load", resolve, { once: true });
      existing.addEventListener("error", reject, { once: true });
      return;
    }
    const script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.src = SCRIPT_SRC;
    script.async = true;
    script.dataset.testid = "metricool-tracker-script";
    script.addEventListener("load", resolve, { once: true });
    script.addEventListener("error", reject, { once: true });
    document.head.appendChild(script);
  });
  return scriptPromise;
}

export default function MetricoolTracker() {
  const location = useLocation();

  useEffect(() => {
    const page = `${location.pathname}${location.search}`;
    if (!TRACKER_HASH || !isMetricoolPublicPath(location.pathname) || lastTrackedPage === page) return undefined;
    let cancelled = false;
    loadMetricool().then(() => {
      if (cancelled || !window.beTracker) return;
      window.beTracker.t({ hash: TRACKER_HASH });
      lastTrackedPage = page;
    }).catch(() => {});
    return () => { cancelled = true; };
  }, [location.pathname, location.search]);

  return null;
}